<template>
  <div>
    <div v-for="client in clientList" :key="client.id">
      <client-list-item :client="client" v-if="showClient(client)"/>
    </div>
    <div v-if="isEmptyList">
      <h5 class="text-center">Empty list</h5>
    </div>
  </div>
</template>

<script>
import ClientListItem from "./ClientListItem";
import Utils from "../../Utils";
export default {
  props:{
    hidePredict:{
      type:Boolean,
      required:false,
      default:false
    },
    externalProvider:{
      type:String,
      required:false,
      default:""
    }
  },
  components: {
    ClientListItem
  },
  computed: {
    clientList() {
      return this.$store.getters["clients/getClientList"];
    },
    isEmptyList() {
      return this.clientList.length === 0;
    },
  },
  methods:{
    showClient(client){
      // If externalProvider filter is set
      if(this.externalProvider) {
        // Client must have matching externalProvider to be shown
        if(!client.registration || 
          !client.registration.externalProvider || 
          client.registration.externalProvider !== this.externalProvider) {
          return false;
        }
      }
      
      // If not hiding predict clients, show everything (that passed externalProvider filter)
      if(!this.hidePredict) return true;
      
      // If hidePredict is true and this is a predict client, hide it
      if(client.clientType === Utils.CLIENT_TYPE.PREDICT) return false;
      
      return true;
    }
  }
};
</script>

<style scoped></style>
